
import { createElement } from "react";
import React from "react";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { stringHash, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { ReactPopover } from "../../Components/ReactPopover.js";

export function ElementsGroup(props) {
    let elems_1;
    const patternInput = reactApi.useState(true);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-max"])], (elems_1 = toList(delay(() => append(singleton(reactElement("div", {
        className: join(" ", ["font-semibold"]),
        children: props.Group,
    })), delay(() => (patternInput[0] ? map((item) => {
        let elems;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["font-medium"])], (elems = [Checkbox({
            ComponentState: "enabled",
            IsChecked: item.Checked,
            Label: item.Name,
            OnCheck: item.OnCheck,
            TestId: "",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }, props.Items) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ColumnSelect(props) {
    const elements = List_groupBy((item) => item.Group, props.Items, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    return createElement(ReactPopover, {
        Body: (_arg) => {
            let elems;
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["p-6", "max-h-[30rem]", "overflow-auto"])], (elems = toList(delay(() => map((tupledArg) => createElement(ElementsGroup, {
                Group: tupledArg[0],
                Items: tupledArg[1],
            }), elements))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        },
        ButtonLabel: props.ButtonLabel,
        ComponentState: props.ComponentState,
        TestId: concat("column-select-popover-", ...props.TestId),
    });
}

